import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import Layout from './components/layout/Layout';

const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const DestinationsPage = lazy(() => import('./pages/DestinationsPage'));
const ApplyPage = lazy(() => import('./pages/ApplyPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const ComingSoonPage = lazy(() => import('./pages/ComingSoonPage'));
const ResourcesPage = lazy(() => import('./pages/ResourcesPage'));
const GuidePage = lazy(() => import('./pages/GuidePage'));
const CalculatorPage = lazy(() => import('./pages/CalculatorPage'));
const VisaPage = lazy(() => import('./pages/VisaPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-surface">
    <div className="text-center">
      <div className="w-12 h-12 border-4 border-secondary/20 border-t-secondary rounded-full animate-spin mx-auto mb-4" />
      <p className="text-text-muted text-sm font-medium">Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#0A2540',
              color: '#fff',
              borderRadius: '12px',
              fontSize: '14px',
            },
          }}
        />
        <Layout>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:slug" element={<ServicesPage />} />
              <Route path="/destinations" element={<DestinationsPage />} />
              <Route path="/destinations/:slug" element={<DestinationsPage />} />
              <Route path="/apply" element={<ApplyPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/universities" element={<ComingSoonPage title="Universities" description="Browse 50+ partner universities across 7 countries — coming soon." />} />
              <Route path="/courses" element={<ComingSoonPage title="Courses & Programs" description="Find the perfect course for your career goals." />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/guide" element={<GuidePage />} />
              <Route path="/calculator" element={<CalculatorPage />} />
              <Route path="/visa" element={<VisaPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/students" element={<ComingSoonPage title="Student Stories" description="1,500+ success stories from our placed students worldwide." />} />
              {/* Legacy routes */}
              <Route path="/country/:countryname" element={<DestinationsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;
